import { render, staticRenderFns } from "./kiosk.vue?vue&type=template&id=7956e694&scoped=true"
import script from "./kiosk.vue?vue&type=script&lang=js"
export * from "./kiosk.vue?vue&type=script&lang=js"
import style0 from "./kiosk.vue?vue&type=style&index=0&id=7956e694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7956e694",
  null
  
)

export default component.exports